import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import Home from './components/home/Home';
import { Global } from './GlobalStyles';
import { ThemeProvider } from 'styled-components';
import { useEffect, useState } from 'react';
import Storage from 'local-storage-fallback';

//return saved theme(if there is) from the localStorage
function getInitialTheme(){
  const savedTheme = Storage.getItem('theme');
  return savedTheme ? JSON.parse(savedTheme) : {mode: 'light'}
}

function App() {

  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(()=>{
    //set the theme in the localStorage
    Storage.setItem('theme', JSON.stringify(theme));
  },[theme])

  return (
    <ThemeProvider theme={theme}>
      <>
        <Global />
        <Router>
          <Switch>
            <Route exact path="/">
              <Home setTheme={setTheme} theme={theme} />
            </Route>
          </Switch>
        </Router>
      </>
    </ThemeProvider>

  );
}

export default App;
